import { useForm } from '@brenger/react';
import * as React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import '../../../assets/user/user.scss';
import { Button, Col, FlashMessage, Heading, InputText, Row, SectionWrapper } from '../../../brenger-shared-ui';
import { translate } from '../../../utils/localization';
import { runValidators } from '../../../utils/validation';
import { PersonSchema } from '../schema';
import { UserProperties } from '../typings';
import { coreClient } from '../../../utils/request';
import { useMutation } from '@tanstack/react-query';

export const PasswordResetPage: React.FC = () => {
  const passwordReset = useMutation({
    mutationFn: coreClient.users.requestPasswordReset,
    onSuccess: () => {
      form.reset();
    },
  });
  const form = useForm({
    initialState: {
      email: '',
    },
    validators: {
      email: val => runValidators(val, PersonSchema[UserProperties.EMAIL]),
    },
  });

  const onSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (form.hasErrors || passwordReset.isPending) {
      return;
    }
    passwordReset.mutate({
      email: form.data.email.value,
    });
  };

  return (
    <SectionWrapper extraClasses={'login-wrapper'} sectionStyle={'white'} centerContent={true}>
      <form onSubmit={onSubmit} noValidate>
        <Heading size={2}>
          <Translate id={'authentication.reset.headline'} />
        </Heading>
        <Row>
          <Col xs={12} extraClasses={'pt-[1em]'}>
            <InputText
              autoComplete="email"
              name="user.email"
              type="text"
              placeholder={translate('form.fields.user.email.label')}
              value={form.data.email.value}
              onChange={email => form.set({ email })}
              meta={{
                error: form.getError('email'),
                showError: form.data.email.isDirty,
              }}
            />
          </Col>
          <Col xs={12} sm={12} extraClasses={'login-errors'}>
            {passwordReset.error && (
              <div className="pt-[1em]">
                <FlashMessage type={'error'} message={passwordReset.error.message} />
              </div>
            )}
            {passwordReset.isSuccess && (
              <div className="pt-[1em]">
                <FlashMessage type={'success'} message={String(translate('authentication.reset.success'))} />
              </div>
            )}
          </Col>
          <Col xs={12} sm={12}>
            <Button
              fullWidth={true}
              loading={passwordReset.isPending}
              disabled={passwordReset.isPending || !form.isDirty || form.hasErrors}
              buttonStyle={'secondary'}
              type="submit"
            >
              <Translate id={'authentication.reset.button'} />
            </Button>
          </Col>
        </Row>
      </form>
    </SectionWrapper>
  );
};
